export default {"src":"/_next/static/media/CARR.fa0ea062.svg","height":18,"width":18};